import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  private changePasswordSubject = new BehaviorSubject<{ isOpen: boolean, userName: string, id: string }>({ isOpen: false, userName: '', id: '' });
  isChangePassword$ = this.changePasswordSubject.asObservable();

  showChangePasswordDialog(userName: string, userId: string) {
    this.changePasswordSubject.next({ isOpen: true, userName: userName, id: userId });
  }

  hideChangePasswordDialog() {
    this.changePasswordSubject.next({ isOpen: false, userName: '', id: '' });
  }
}
